import {
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription, finalize, map, startWith, tap } from 'rxjs';
import { initializeEditor } from 'src/app/utils/storage/editorConfig';
import { helper } from 'src/environments/helper';
import { CereriService } from '../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

import { DocumentGenerabilComponent } from './document-generabil/document-generabil.component';
import { MatDialog } from '@angular/material/dialog';

import {
    Cerere,
    DocumentCetatean,
    RequestMessageInternPayload,
    RequestMessageNotitaPayload,
    RequestMessageToCetateanPayload,
    DocumentGenerabil,
    Coleg,
} from '../cerere.interface';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { StorageService } from 'src/app/utils/storage/storage.service';
import { environment } from 'src/environments/environment';

import { AppFilesService } from 'src/app/services/app-files.service';
import { COMMA, ENTER, L } from '@angular/cdk/keycodes';
import { CommonService } from 'src/app/services/common.service';
import { CerereValidareComponent } from './cerere-validare/cerere-validare.component';
import { EditDocumentOficialComponent } from './document-generabil/edit-document-oficial/edit-document-oficial.component';
import { IstoricDocumentGenerabilComponent } from './document-generabil/istoric-document-generabil/istoric-document-generabil.component';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { UsersService } from 'src/app/services/users.service';
import { ModalInchidereLucrareComponent } from './modal-inchidere-lucrare/modal-inchidere-lucrare.component';
import { DialogService } from 'src/app/utils/dialog.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { CerereDetaliiSabloaneComponent } from './sabloane/cerere-detalii-sabloane.component';
import { RegistruValabilityComponent } from './registru-valability/registru-valability.component';
import { requireMinOneColleagueValidator } from 'src/app/validators/at-least-one-colleague';
import { UpdateGenerabilValabilityComponent } from './document-generabil/update-generabil-valability/update-generabil-valability.component';
import { OpenUploadedFilesComponent } from "src/app/shared/subsemnat/open-uploaded-files/open-uploaded-files.component";
import { BreakpointObserver } from '@angular/cdk/layout';
import { DocumentTemplateSignaturesComponent } from 'src/app/platform/nomenclatoare/document-template/document-template-signatures/document-template-signatures.component';

@Component({
    selector: "app-cereri-detalii",
    templateUrl: "./cereri-detalii.component.html",
    styleUrls: ["./cereri-detalii.component.scss"],
})
export class CereriDetaliiComponent implements OnInit, OnDestroy {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    token!: string;
    isLoading = false;
    isActualizareCerereLoading = false;
    isDocumentOficialDisabled = false;
    selectedDocGenerabilToggle = "active";
    selectedDocToggle = "cereri";
    //selectedMessageToggle = 'cetatean';
    selectedMessagingToggle = "internalMsg";
    selectedInfoExtra = "info";
    selectedPFStatus = "info";
    passedRequestId!: number;
    helper = helper;
    editorConfig!: AngularEditorConfig;
    safeHtml!: SafeHtml;
    documentTypesTranslation: any = {
        'toPrimarie': 1,
        'toCetatean': 2
    }
    documentTypesTranslationReverse: any = {
        1: 'toPrimarie',
        2: 'toCetatean'
    }

    showSignatures: any;
    cerere!: any;
    informatii_aditionale: any = this.cerere?.informatii;
    documenteCetatean!: DocumentCetatean[];
    documentCategories!: any[];

    sendMessageCetateanForm!: FormGroup;
    sendMessageInternForm!: FormGroup;
    sendMessageNotitaForm!: FormGroup;
    notifyAnswer!: FormGroup;

    uploadedFileNames: string[] = [];

    showValidateCard: boolean = true;

    user: any = null;
    timestamp = this.cerere?.cetatean.created_at;
    date_hour =
        this.timestamp?.slice(0, 10) + " " + this.timestamp?.slice(11, 16);

    defaultChoiceParameter: { name: string; id: string } = {
        name: "-- Alegeți --",
        id: "-1",
    };

    responseTimes = [
        { key: "3", value: 3 },
        { key: "5", value: 5 },
        { key: "7", value: 7 },
        { key: "10", value: 10 },
    ];

    uploading: any = {
        files_mesagerie_cetatean: false,
        files_mesagerie_intern: false,
        files_mesagerie_notita: false,
    };

    files: any = {
        files_mesagerie_cetatean: [],
        files_mesagerie_intern: [],
        files_mesagerie_notita: [],
    };
    hasDraft!: boolean;
    // Add coleagues functionality

    separatorKeysCodes: number[] = [ENTER, COMMA];
    filteredColeagues!: any;
    coleagues: Coleg[] = [];
    allColeagues: Coleg[] = [];
    coleaguesCtrl = new FormControl("");
    source_type!: {};

    selectedSignature: number = -1
    destination_signatures_document: string = 'toPrimarie';

    @ViewChild("coleagueInput") coleagueInput!: ElementRef<HTMLInputElement>;

    // Subscription to track our sabloane added from the button below messaging component
    private contentSubscription!: Subscription;
    docAndHistoryToggle = "doc";

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<CereriDetaliiComponent>,
        private cereriService: CereriService,
        private notificationService: NotificationService,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private authService: AuthService,
        private userService: UsersService,
        private fb: FormBuilder,
        private storageService: StorageService,
        private sanitizer: DomSanitizer,
        private appFileService: AppFilesService,
        private commonService: CommonService,
        public toastr: ToastrService,
        public permissionsService: PermissionsService,
        private breakpointObserver: BreakpointObserver,
    ) {
        this.processToken();
        this.passedRequestId = this.data.cerere.id_cerere;
        this.source_type = this.data.cerere.source_type;
    }

    onDestinatieChange(event: any, doc: any = null) {
        console.log(event, 'event?')
        if (doc !== null) {
            this.getSignatureList(doc)
        }
    }

    showEditSemnatari: boolean = false;
    selectSemnatariList: any = []
    editSemnatari(event: any, doc: any = null): void {
        this.showEditSemnatari = !this.showEditSemnatari;
        if (doc !== null && this.showEditSemnatari == true) {
            this.getSignatureList(doc)
        }
    }

    getSignatureList(doc: any = null) {
        // Reset selectSemnatariList
        this.selectSemnatariList = [];

        if (doc !== null && this.showEditSemnatari == true) {
            this.selectedSignature = doc.validare_user_type
            console.log(doc)
            let extraOption = {
                user_type: 0,
                user_type_name: "Intocmitor"
            }
            this.selectSemnatariList.push(extraOption)
            let indexSignatureTypes: any = this.documentTypesTranslation[this.destination_signatures_document]
            // exactly our list - specified :)
            doc.signatures_doc[indexSignatureTypes].forEach((item: any) => {
                let obj = {
                    user_type: item.user_type,
                    user_type_name: item.user_type_name
                }
                this.selectSemnatariList.push(obj);
            })
        }
    }

    editSemnatariSubmit(idDocGenerat: number) {
        // Swal.fire({
        // 	title: helper.dialogConfig.commonTitles.areYouSure,
        // 	text: 'O să modificati semnatarul curent. Continuați?',
        // 	icon: 'warning',
        // 	showCancelButton: true,
        // 	cancelButtonText: helper.dialogConfig.buttonLabels.close,
        // 	confirmButtonColor: helper.dialogConfig.colorButtons.standard,
        // 	confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
        // 	showLoaderOnConfirm: true,
        // 	reverseButtons: true,
        // 	allowOutsideClick: false,
        // }).then((result) => {
        // 	if (result.isConfirmed) {
        // 		this.isLoading = true;

        // 		this.getRequestInfo();
        // 		this.showEditSemnatari = false;
        // 	}
        // });

        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să modificati semnatarul curent. Continuați?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                let data = {
                    destination_signatures_document: this.destination_signatures_document,
                    selectedSignature: this.selectedSignature
                }
                return this.cereriService
                    .updateCurrentSignatureDocument(idDocGenerat, data)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        let errorMessage = 'Eroare neașteptată.';
                        if (
                            error &&
                            error.error &&
                            error.error.errors &&
                            error.error.errors.message &&
                            error.error.errors.message.length > 0
                        ) {
                            errorMessage = error.error.errors.message[0];
                        }
                        console.log(errorMessage);

                        Swal.showValidationMessage(`Request failed: ${errorMessage}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                    this.editSemnatari('hello');
                });
            }
        });
    }

    //  onSignatureSelect() { }
    processUserDetails() {
        var self = this;
        const userObj = self.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                self.user = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    ngOnInit(): void {
        const htmlFromBackend = `<span><span class='fa fa-clock-o'></span> 30z</span> <span class='green-text'><b>27z 21h </b></span>`;
        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(htmlFromBackend);

        this.getRequestInfo();
        this.editorConfig = initializeEditor();
        this.getUsersActive();
        this.initializeCetateanForm();
        this.initNotifyAnswer();
        this.subscribeToContent();

        this.sendMessageInternForm = this.fb.group({
            message: new FormControl("", [Validators.required]),
            type: new FormControl("2"),
            coleagues: new FormControl(
                this.coleagues,
                requireMinOneColleagueValidator()
            ),
            files: this.fb.array([]),
            notify: new FormControl(false),
        });
        this.sendMessageNotitaForm = this.fb.group({
            message: new FormControl("", [Validators.required]),
            type: new FormControl("3"),
            files: this.fb.array([]),
            notify: new FormControl(false),
        });

        this.filteredColeagues = this.coleaguesCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value ? this._coleaguesFilter(value) : this.allColeagues.slice()
            )
        );
    }

    addSemnatari(doc: any) {
        console.log(doc.id_document);
        let isCerereDetalii = true;
        let data = {
            manual_override: true,
            // id_document: doc.id_document, // id_document generat
            id: doc.id_document, // template ID
            document_generabil_dual: doc.doc_type, // document_generabil_dual - doc_type - exemplar
            doc_type: this.documentTypesTranslation[this.destination_signatures_document], // document_generabil_dual - doc_type - exemplar
            name: doc.template // denumire template
        };
        const dialogRef = this.dialog.open(DocumentTemplateSignaturesComponent, {
            height: '70vh',
            maxHeight: '70vh',
            width: '75vh',
            maxWidth: '75vh',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }) => {
            if (success) {
                this.isLoading = true;
                this.rsyncSignaturesDocumentGenerat(doc.id_document, data.doc_type);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.contentSubscription) {
            this.contentSubscription.unsubscribe();
        }
    }

    initNotifyAnswer() {
        this.notifyAnswer = new FormGroup({
            notify_date_expire: new FormControl("", [Validators.required]),
        });
    }

    initializeCetateanForm() {
        this.sendMessageCetateanForm = this.fb.group({
            message: new FormControl("", [Validators.required]),
            type: new FormControl("1"),
            coleagues: new FormControl([]),
            files: this.fb.array([]),
            notify: new FormControl(false),
        });
    }

    // This subscribes to any content change coming from Sabloane button below
    subscribeToContent() {
        this.contentSubscription = this.cereriService.sablonContent$.subscribe({
            next: (content) => {
                this.updateMessageFormControl(content);
            },
        });
    }
    // This updated our form control
    updateMessageFormControl(content: string) {
        // Update the 'message' form control with the new content
        this.sendMessageCetateanForm.controls["message"].setValue(content);
    }

    getDocumentTypeKeys(): string[] {
        return this.cerere ? Object.keys(this.cerere.documente) : [];
    }

    getDocumentKeys(docTypeKey: string): string[] {
        return this.cerere
            ? Object.keys(this.cerere.documente[docTypeKey].documente)
            : [];
    }

    prepareDocumentCategories(): void {
        if (this.cerere && this.cerere.documente) {
            this.documentCategories = Object.keys(this.cerere.documente).map(
                (key) => this.cerere?.documente[key]
            );
        }
    }

    handleButtonClick(buttonValue: string) {
        switch (buttonValue.toLowerCase()) {
            case "validează":
                this.confirmValidareSolicitare();
                break;
            case "invalidează":
                this.showValidateCard = false;
                this.confirmInValidareSolicitare();
                break;
            case "anulare":
            case "clasare":
                this.confirmAnulareSolicitare();
                break;
            case "închidere lucrare":
                this.openInchidereSolicitare(this.cerere);
                break;
            default:
                console.log("Unrecognized button value", buttonValue.toLowerCase());
        }
    }

    handleButtonResetClick(buttonValue: string) {
        switch (buttonValue.toLowerCase()) {
            case "validează":
                this.resetValidareCerere();
                break;
            case "invalidează":
                this.resetinValidareCerere();
                break;
            case "anulare":
            case "clasare":
                this.resetClasareCerere();
                break;
            case "închidere lucrare":
                this.resetInchidereCerere();
                break;
            default:
                console.log("Unrecognized button value", buttonValue.toLowerCase());
        }
    }

    getRequestInfo() {
        this.isLoading = true;
        this.cereriService
            .getRequestById(this.passedRequestId)
            .pipe(map((response: any) => response.data))
            .subscribe((requestData) => {
                this.isLoading = false;
                this.cerere = requestData;
                this.hasDraft = requestData.hasDraft;
                this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(
                    (this.cerere as Cerere).sla
                );
                if (
                    typeof this.cerere?.generabile !== "undefined" &&
                    this.cerere.generabile.length > 0
                ) {
                    this.showSignatures = this.cerere.generabile[0].id_document;
                }
            },
                (error: any) => {
                    this.isLoading = false;
                    console.error('Error', error);
                    let msg;
                    try {
                        msg = error.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService
                        .warningSwal(this.errorTitle, msg, this.errorIcon)
                        .then((result) => {
                            this.closeDialog();
                        });
                });
    }

    // Coleagues section

    private _coleaguesFilter(value: string | Coleg): Coleg[] {
        let filterValue = "";
        if (typeof value === "string") {
            filterValue = value.toLowerCase();
        } else {
            filterValue = value.name.toLowerCase();
        }

        return this.allColeagues.filter((coleague) =>
            coleague.name.toLowerCase().includes(filterValue)
        );
    }

    addColeague(event: MatChipInputEvent): void {
        const value = (event.value || "").trim();

        if (value) {
            const foundOption = this.allColeagues.find(
                (coleague) => coleague.name.toLowerCase() === value.toLowerCase()
            );
            if (foundOption) {
                this.coleagues.push(foundOption);
                this.sendMessageInternForm.controls["coleagues"].setValue([
                    ...this.coleagues,
                ]);
                this.sendMessageInternForm.controls[
                    "coleagues"
                ].updateValueAndValidity();
            }
        }

        event.chipInput!.clear();
        this.coleaguesCtrl.setValue(null);
    }

    removeColeague(coleague: Coleg): void {
        const index = this.coleagues.indexOf(coleague);

        if (index >= 0) {
            this.coleagues.splice(index, 1);

            this.sendMessageInternForm.controls["coleagues"].setValue([
                ...this.coleagues,
            ]);
            this.sendMessageInternForm.controls["coleagues"].updateValueAndValidity();
        }
    }

    selectedColeagues(event: MatAutocompleteSelectedEvent): void {
        const selectedOption = this.allColeagues.find(
            (coleague) => coleague.name === event.option.viewValue
        );
        if (
            selectedOption &&
            !this.coleagues.find(
                (coleague) => coleague.id_user === selectedOption.id_user
            )
        ) {
            this.coleagues.push(selectedOption);
            this.coleagueInput.nativeElement.value = "";
            this.coleaguesCtrl.setValue(null);
            // Update the form control to reflect changes and re-validate
            this.sendMessageInternForm.controls["coleagues"].setValue([
                ...this.coleagues,
            ]);
            this.sendMessageInternForm.controls["coleagues"].updateValueAndValidity();
        }
    }

    getUsersActive() {
        this.userService
            .getUsersActive()
            .pipe(map((response: any) => response.data))
            .subscribe((requestData) => {
                this.allColeagues = requestData;
            });
    }

    onFileSelected(event: any, section: any) {
        const files = event.target.files;
        if (files) {
            var filesArray;
            switch (section) {
                case "cetatean":
                    filesArray = this.sendMessageCetateanForm.get("files") as FormArray;
                    break;

                case "intern":
                    filesArray = this.sendMessageInternForm.get("files") as FormArray;
                    break;

                case "nota":
                    filesArray = this.sendMessageNotitaForm.get("files") as FormArray;
                    break;
            }

            Array.from(files).forEach((file: any) => {
                if (!this.uploadedFileNames.includes(file.name)) {
                    this.uploadedFileNames.push(file.name);
                    const fileControl = new FormControl(file);

                    filesArray.push(fileControl);
                }
            });
        }
    }

    deleteFile(fileName: string, section: any) {
        const nameIndex = this.uploadedFileNames.indexOf(fileName);
        if (nameIndex > -1) {
            this.uploadedFileNames.splice(nameIndex, 1);
        }
        var filesArray: any;
        switch (section) {
            case "cetatean":
                filesArray = this.sendMessageCetateanForm.get("files") as FormArray;
                break;

            case "intern":
                filesArray = this.sendMessageInternForm.get("files") as FormArray;
                break;

            case "nota":
                filesArray = this.sendMessageNotitaForm.get("files") as FormArray;
                break;
        }

        // const filesArray = this.sendMessageForm.get('files') as FormArray;
        const fileIndex = filesArray.controls.findIndex(
            (control: any) => control.value.name === fileName
        );
        if (fileIndex > -1) {
            filesArray.removeAt(fileIndex);
        }
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token: string) => {
            this.token = token;
            this.cereriService.setToken(token);
            this.processUserDetails();
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    onDocGenerabilChange(event: MatButtonToggleChange) {
        this.selectedDocGenerabilToggle = event.value;
    }

    onDocChange(event: MatButtonToggleChange) {
        this.selectedDocToggle = event.value;
    }

    // onMessageChange(event: MatButtonToggleChange) {
    //     this.selectedMessageToggle = event.value;
    // }

    onMessagingChange(event: MatButtonToggleChange) {
        this.selectedMessagingToggle = event.value;
    }

    resetAllForms() {
        if (this.sendMessageInternForm.value) {
            this.coleagues = [];
            this.sendMessageInternForm.get("message")?.setValue(null);
            this.sendMessageInternForm.get("type")?.setValue("2");
            this.sendMessageInternForm.get("notify")?.setValue(false);

            const filesFormArray = this.sendMessageInternForm.get(
                "files"
            ) as FormArray;
            filesFormArray.clear();
            this.sendMessageInternForm.clearValidators();
        }

        if (this.sendMessageCetateanForm.value) {
            this.sendMessageCetateanForm.get("message")?.setValue("");
            this.sendMessageCetateanForm.get("type")?.setValue("1");
            this.sendMessageCetateanForm.get("notify")?.setValue(false);
            this.notifyAnswer.get("notify_date_expire")?.setValue(null);

            const filesFormArray = this.sendMessageCetateanForm.get(
                "files"
            ) as FormArray;
            filesFormArray.clear();
            this.sendMessageCetateanForm.clearValidators();
        }

        if (this.sendMessageNotitaForm.value) {
            this.sendMessageNotitaForm.get("message")?.setValue("");
            this.sendMessageNotitaForm.get("type")?.setValue("3");
            this.sendMessageNotitaForm.get("notify")?.setValue(false);

            const filesFormArray = this.sendMessageNotitaForm.get(
                "files"
            ) as FormArray;
            filesFormArray.clear();
            this.sendMessageNotitaForm.clearValidators();
        }
    }

    submitMessage(section: any) {
        this.isLoading = true;

        var newMessage;
        switch (section) {
            case "cetatean":
                newMessage = this.sendMessageCetateanForm
                    .value as RequestMessageToCetateanPayload;

                if (this.sendMessageCetateanForm.get("notify")?.value === true) {
                    newMessage = Object.assign(newMessage, {
                        notify_date_expire: this.notifyAnswer.value.notify_date_expire,
                    });
                }
                break;
            case "intern":
                newMessage = this.sendMessageInternForm
                    .value as RequestMessageInternPayload;
                break;

            case "nota":
                newMessage = this.sendMessageNotitaForm
                    .value as RequestMessageNotitaPayload;
                break;
        }

        this.cereriService
            .postMessage(this.cerere!.id_cerere, newMessage)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                    this.uploadedFileNames = [];
                    this.resetAllForms();
                })
            )
            .subscribe({
                next: (res) => {
                    this.isLoading = true;
                    // Commented the function below so that we dont have a popup when the loading spinner is active

                    // this.notificationService.warningSwal(
                    //   this.successTitle,
                    //   'Cerere actualizata cu succes!',
                    //   this.successIcon
                    // );
                    // refresh data please
                    this.getRequestInfo();

                    switch (section) {
                        case "cetatean":
                            this.sendMessageCetateanForm.patchValue({
                                message: "",
                                files: [],
                            });
                            this.notifyAnswer.patchValue({
                                notify: false,
                                notify_date_expire: null,
                            });
                            break;

                        case "intern":
                            this.sendMessageInternForm.patchValue({
                                message: "",
                                files: [],
                                coleagues: this.coleagues,
                            });
                            break;

                        case "nota":
                            this.sendMessageNotitaForm.patchValue({
                                message: "",
                                files: [],
                            });
                            break;
                    }

                    // this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    confirmPreluarePersonala() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "O să preluați solicitarea curentă. Continuați?",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .preluarePersonala(this.cerere!.id_cerere)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    "Cerere preluată cu succes!",
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    confirmInValidareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.invalidate,
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text", // Enable text input
            inputPlaceholder: this.helper.swalTextConfig.inputPlaceholders.invalidate,
            inputValidator: (value: any) => {
                if (!value) {
                    return "Este necesar completarea un motiv de invalidare!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .invalidateCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    confirmAnulareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.clasare,
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text", // Enable text input
            inputPlaceholder: this.helper.swalTextConfig.inputPlaceholders.cancel,
            inputValidator: (value) => {
                if (!value) {
                    return "Este necesar completarea unui motiv..!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .anulareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    confirmValidareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.validate,
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .validateCerere(this.cerere?.id_cerere)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(
                            `Request failed: ${error.errors.message[0]}`
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    openInchidereSolicitare(data: Cerere) {
        let dialogRef = this.dialog.open(ModalInchidereLucrareComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
        });
    }

    downloadDocument(file: any) {
        let fullPath = this.cereriService.downloadDocumentUrl + file.id;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentTableSignatures(id: number) {
        let fullPath = this.cereriService.downloadTableSignaturesURL + id;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentGeneratBE(id: number, doc_type?: number) {
        let fullPath = this.cereriService.downloadDocumentGeneratUrl + id + '/' + doc_type;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentGeneratBEWithDocType(id: number, doc_type: number) {
        let fullPath1 = this.cereriService.downloadDocumentGeneratUrl + id + `/${doc_type}?file_type=1`;
        let fullPath2 = this.cereriService.downloadDocumentGeneratUrl + id + `/${doc_type}?file_type=2`;

        this.isLoading = true;
        this.appFileService.downloadFile(fullPath1)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })

        this.isLoading = true;
        this.appFileService.downloadFile(fullPath2)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
        // this.appFileService.downloadToClient(fullPath1, 'file_type_1');
        // this.appFileService.downloadToClient(fullPath2, 'file_type_2');
    }

    downloadDocumentOfficial(id: number) {
        // let fullPath = this.cereriService.downloadDocumentSignedUrl + id; // wrong ?
        let fullPath = this.cereriService.downloadDocumentOfficialUrl + id;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentSigned(id: number) {
        let fullPath = this.cereriService.downloadDocumentSignedUrl + id;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentFromSignatureSigned(id: number) {
        let fullPath = this.cereriService.downloadDocumentSignatureSignedUrl + id;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadAnexa(file: any) {
        let fullPath = this.cereriService.downloadDocumentAnexaUrl + file.id;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    addFileCetatean(event: any, key: "file") {
        event.eventPreventDefault = true;
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploading[key] = true;

            const formData = new FormData();
            formData.append("file", file, file.name);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== "undefined" ? result : result.error;
                    if (typeof response.status_code !== "undefined") {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== "undefined"
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.sendMessageCetateanForm.get(
                                "files"
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;
                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }
    }

    addFileIntern(event: any, key: "file") {
        event.eventPreventDefault = true;
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploading[key] = true;

            const formData = new FormData();
            formData.append("file", file, file.name);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== "undefined" ? result : result.error;
                    if (typeof response.status_code !== "undefined") {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== "undefined"
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.sendMessageInternForm.get(
                                "files"
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;

                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }
    }

    addFileNotita(event: any, key: "file") {
        event.eventPreventDefault = true;
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploading[key] = true;

            const formData = new FormData();
            formData.append("file", file, file.name);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== "undefined" ? result : result.error;
                    if (typeof response.status_code !== "undefined") {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== "undefined"
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            // const currentFiles = this.sendMessageNotitaForm.get('files')?.value || [];
                            // currentFiles.push(result.data);
                            // this.sendMessageNotitaForm.get('files')?.setValue(currentFiles);
                            const files = this.sendMessageNotitaForm.get(
                                "files"
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;

                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    removeFileCetatean(index: number) {
        const files = this.sendMessageCetateanForm.get("files") as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    removeFileIntern(index: number) {
        const files = this.sendMessageInternForm.get("files") as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    removeFileNota(index: number) {
        const files = this.sendMessageNotitaForm.get("files") as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    docHistory(event: MatButtonToggleChange) {
        this.docAndHistoryToggle = event.value;
    }

    generateDocOfficial() {
        const is_address = false;

        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            disableClose: true,
            panelClass: 'scroll-modalbox',
            data: {
                cerere: this.cerere,
                type: 1, // doc official
                is_address: is_address,
            }
        };

        const dialogRef = this.dialog.open(DocumentGenerabilComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 699px)', // xs breakpoint
            '(min-width: 700px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 699px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('60%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    generateAdresa() {
        const is_address = true;

        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            disableClose: true,
            panelClass: 'scroll-modalbox',
            data: {
                cerere: this.cerere,
                type: 3, // adrese
                is_address: is_address,
            }
        };

        const dialogRef = this.dialog.open(DocumentGenerabilComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 699px)', // xs breakpoint
            '(min-width: 700px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 699px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('60%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    generateDocInstiintare() {
        const is_address = true;

        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            disableClose: true,
            panelClass: 'scroll-modalbox',
            data: {
                cerere: this.cerere,
                type: 2, // doc instiintare
                is_address: is_address,
            }
        };

        const dialogRef = this.dialog.open(DocumentGenerabilComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 699px)', // xs breakpoint
            '(min-width: 700px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 699px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('60%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    updateDocumentGenerat(row: DocumentGenerabil) {
        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            disableClose: true,
            panelClass: 'scroll-modalbox',
            data: row
        };

        const dialogRef = this.dialog.open(EditDocumentOficialComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 699px)', // xs breakpoint
            '(min-width: 700px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 699px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('60%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    downloadDocumentGenerat(row: DocumentGenerabil, doc_type: number) {
        if (row.file_signed_final !== null) {
            this.downloadDocumentOfficial(row.id_document);
        } else if (row.file_signed !== null) {
            this.downloadDocumentSigned(row.id_document);
        } else {
            this.downloadDocumentGeneratBEWithDocType(row.id_document, doc_type);
        }
    }

    validateDocument(documentGeneratId: number, type: number = 1) {
        Swal.fire({
            title: this.helper.swalTextConfig.headers.error,
            text: this.helper.swalTextConfig.generalMessages.validateDocument,
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .validateDocument(documentGeneratId, { type: type })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error);
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .validateDocumentSuccess,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    cancelDocument(documentGeneratId: number, data: any) {
        console.log(documentGeneratId);

        Swal.fire({
            title: this.helper.swalTextConfig.headers.error,
            text: this.helper.swalTextConfig.generalMessages.deleteDocument,
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text", // Enable text input
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            inputValidator: (value) => {
                if (!value) {
                    return "Este necesar completarea unui motiv!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .anulareSuperiorDocument(documentGeneratId, inputValue)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error);
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentSuccess,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    viewIstoricDocument(row: Cerere) {
        const dialogRef = this.dialog.open(IstoricDocumentGenerabilComponent, {
            minHeight: "50vh",
            maxHeight: "50vh",
            minWidth: "60vw",
            maxWidth: "60vw",
            disableClose: true,
            data: row.istoric,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
        });
    }

    destroyDocumentGenerat(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.deleteDocument,
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text", // Enable text input
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            inputValidator: (value) => {
                if (!value) {
                    return "Este necesar completarea unui motiv!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .destroyDocument(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                this.isDocumentOficialDisabled = false;
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentSuccess,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    switchViewSignatures(doc: any) {
        this.showSignatures = doc.id_document;
        console.log(this.showSignatures);
        this.showEditSemnatari = false;

        // get document info
        this.destination_signatures_document = this.documentTypesTranslationReverse[doc.doc_type_active]
    }

    downloadSignedDocument(documentId: number, userType: number) {
        // console.log(documentId, "documentId", userType, "userType");
    }

    resetDocument(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.headers.error,
            text: this.helper.swalTextConfig.generalMessages.confirmReset,
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text", // Enable text input
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            inputValidator: (value) => {
                if (!value) {
                    return "Este necesar completarea unui motiv!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .resetDocumentValidated(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error);
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentSuccess,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetDocumentIntocmitor(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.headers.error,
            text: this.helper.swalTextConfig.generalMessages.confirmReset,
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text", // Enable text input
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            inputValidator: (value) => {
                if (!value) {
                    return "Este necesar completarea unui motiv!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .resetDocumentIntocmitorValidated(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error);
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentSuccess,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    // this.isDocumentOficialDisabled = true; // i don't understand this rule.. i need explination please :)
                    this.getRequestInfo();
                });
            }
        });
    }

    anulareCerereSuperior(signatureId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.deleteDocumentCancel,
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text",
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            inputValidator: (value) => {
                if (!value) {
                    return "Este necesar completarea unui motiv!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .anulareSuperiorDocument(signatureId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentCancelSuccess,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    isObjectEmpty(obj: any): boolean {
        return obj && Object.keys(obj).length === 0;
    }

    onCerereChanged(isEmitted: boolean) {
        isEmitted ? this.getRequestInfo() : null;
    }

    onInfoExtraChange(event: MatButtonToggleChange) {
        this.selectedInfoExtra = event.value;
    }

    onPFInfoChange(event: MatButtonToggleChange) {
        this.selectedPFStatus = event.value;
    }

    // This function checks if all signatures are not null inside a signature array of objects for a any doc generabil
    allFilesSigned(signatures: any): boolean {
        return signatures.every((signature: any) => (signature.type == 1 && signature.action_date !== null));
        // return signatures.every((signature: any) => signature.file_signed !== null);
    }

    openRegistruValability(data: any) {
        // console.log(data);
        const dialogRef = this.dialog.open(RegistruValabilityComponent, {
            minWidth: "40vw",
            maxWidth: "40vw",
            data: {
                id_document: data.id_document,
                passedRequestId: this.passedRequestId,
                valability: data.valability,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
        });
    }

    showPreluareNumarRegistratura() {
        return (
            this.cerere?.id_user_assigned !== null &&
            this.cerere?.id_user_assigned == this.user.id_user &&
            this.cerere?.indoc_number == null &&
            this.permissionsService.hasPermission(
                "autcom-module.cerere.generare_numar_solicitare_cerere"
            )
        );
    }

    confirmPreluareNumarRegistratura() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "Veți prelua un număr de registratură pentru solicitarea curentă. Continuați?",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .preluareNumarRegistratura(this.cerere!.id_cerere)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    "Număr de registratură preluat cu succes!",
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    openSabloane() {
        const dialogRef = this.dialog.open(CerereDetaliiSabloaneComponent, {
            minHeight: "100vh",
            maxHeight: "100vh",
            minWidth: "50vw",
            maxWidth: "50vw",
            disableClose: true,
        });

        dialogRef
            .afterClosed()
            .subscribe(({ success }: { success: boolean }) => { });
    }

    sendDocumentToIntocmitor(signatureId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "O sa trimiteti documentul inapoi pe flux la Intocmitor",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text",
            inputPlaceholder: "Completati motivul...",
            inputValidator: (value) => {
                if (!value) {
                    return "Este necesar completarea unui motiv!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .sendDocumentToIntocmitor(signatureId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: "Operatiune rulata cu succes.",
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    sendDocumentForwardIntocmitor(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "O sa trimiteti documentul mai departe pe flux confirmand documentul incarcat ca fiind cel corect",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text",
            inputPlaceholder: "Completati motivul...",
            inputValidator: (value) => {
                if (!value) {
                    return "Este necesar completarea unui motiv!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .sendDocumentForwardIntocmitor(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: "Operatiune rulata cu succes.",
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    sendDocumentForwardToSigner(signatureId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "O sa trimiteti documentul mai departe pe flux confirmand documentul incarcat ca fiind cel corect",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: "text",
            inputPlaceholder: "Completati motivul...",
            inputValidator: (value) => {
                if (!value) {
                    return "Este necesar completarea unui motiv!";
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .sendDocumentForwardToSigner(signatureId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: "Operatiune rulata cu succes.",
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    rsyncSignaturesDocumentGenerat(documentId: number, doc_type: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "O să resetați semnatarii. Continuați?",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .rsyncSignaturesDocumentGenerat(documentId, doc_type)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    "Semnatari resetați cu succes!",
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    generareDraftBtn() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "Doriți să generați documentul?",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .generareDraft(this.cerere.id_cerere)
                    .pipe(finalize(() => (this.isLoading = false)))

                    .subscribe({
                        next: (res: Blob) => {
                            this.isLoading = true;
                            const blobUrl = URL.createObjectURL(res);
                            window.open(blobUrl, "_blank");
                            this.notificationService.warningSwal(
                                this.successTitle,
                                "Document generat cu succes!",
                                this.successIcon
                            );
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    // special operations, we need to reset states of special activities on cerere
    resetValidareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "Sunteti sigur ca doriti resetarea validarii de cerere?",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: "text", // Enable text input
            inputPlaceholder: "Necesita completarea motivului...",
            inputValidator: (value: any) => {
                if (!value) {
                    return "Este necesar completarea un motiv";
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log("empty message");
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage("Este necesar completarea unui motiv!");
                }

                return this.cereriService
                    .resetValidareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error, "error from BE");
                        Swal.showValidationMessage(
                            `Request failed: ${error.error.errors.message[0]}`
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetinValidareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "Sunteti sigur ca doriti resetarea inValidarii de cerere?",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: "text", // Enable text input
            inputPlaceholder: "Necesita completarea motivului...",
            inputValidator: (value: any) => {
                if (!value) {
                    return "Este necesar completarea un motiv";
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log("empty message");
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage("Este necesar completarea unui motiv!");
                }

                return this.cereriService
                    .resetinValidareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error, "error from BE");
                        Swal.showValidationMessage(
                            `Request failed: ${error.error.errors.message[0]}`
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetClasareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "Sunteti sigur ca doriti resetarea clasarii de cerere?",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: "text", // Enable text input
            inputPlaceholder: "Necesita completarea motivului...",
            inputValidator: (value: any) => {
                if (!value) {
                    return "Este necesar completarea un motiv";
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log("empty message");
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage("Este necesar completarea unui motiv!");
                }

                return this.cereriService
                    .resetClasareCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error, "error from BE");
                        Swal.showValidationMessage(
                            `Request failed: ${error.error.errors.message[0]}`
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    resetInchidereCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "Sunteți sigur că doriți resetarea închiderii de cerere? Confirmați anularea de închidere a cerere în cadrul modulului de INDOC - Registratură?",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: "text", // Enable text input
            inputPlaceholder: "Necesită completarea motivului...",
            inputValidator: (value: any) => {
                if (!value) {
                    return "Este necesar completarea un motiv";
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log("empty message");
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage("Este necesar completarea unui motiv!");
                }

                return this.cereriService
                    .resetInchidereCerere(this.cerere!.id_cerere, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error, "error from BE");
                        Swal.showValidationMessage(
                            `Request failed: ${error.error.errors.message[0]}`
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    notificareCetateanDocumentOficial(documentId: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "Doriți să trimiteți/notificați cetățeanul privind documentul/documentele oficiale încărcate?",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log("empty message");
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage("Este necesar completarea unui motiv!");
                }

                return this.cereriService
                    .sendNotificationCetateanDocumentOficial(documentId)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error, "error from BE");
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: "Notificare trimisă cu succes!",
                    icon: "success",
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    editDateDocGenerabil(id_document: number) {
        const dialogRef = this.dialog.open(UpdateGenerabilValabilityComponent, {
            minWidth: "40vw",
            maxWidth: "40vw",
            data: id_document,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getRequestInfo();
            }
        });
    }

    resetUploadDocumentOfficial(id_document: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "O să resetați documentul. Continuați?",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .resetUploadDocumentOfficial(id_document)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    "Document resetat cu succes!",
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    resetDocumentOficialNotificareCetatean(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "O să resetați documentul. Continuați?",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .resetDocumentOficialNotificareCetatean(id)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    "Document resetat cu succes!",
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    openUploadedFiles() {
        let dialogRef = this.dialog.open(OpenUploadedFilesComponent, {
            ...this.dialogService.getDialogConfig(),
            data: this.cerere,
        });
    }
    getHasDocuments(): boolean {
        const documente = this.cerere.documente;
        if (documente && typeof documente === "object") {
            return Object.keys(documente).length === 0;
        }
        return true;
    }

    // actualizare document generat - setare tip document
    setDocTypeForDocument(idDocGenerat: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "O sa actualizati tipul documentului Generat/In lucru",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return this.cereriService
                    .setDocTypeForDocument(idDocGenerat)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        let errorMessage = 'Eroare neașteptată.';
                        if (
                            error &&
                            error.error &&
                            error.error.errors &&
                            error.error.errors.message &&
                            error.error.errors.message.length > 0
                        ) {
                            errorMessage = error.error.errors.message[0];
                        }
                        console.log(errorMessage);

                        Swal.showValidationMessage(`Request failed: ${errorMessage}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getRequestInfo();
                });
            }
        });
    }

    updateSla() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "O să actualizați Sla. Continuați?",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .updateSla(this.passedRequestId)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    "Sla actualizat cu succes!",
                                    this.successIcon
                                )
                                .then(() => this.getRequestInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    onIsLoadingChange(event: boolean) {
        this.isLoading = event;
    }
}
